!function() {
  var leafPrototypes, getProto, inProgress, __webpack_modules__ = {
    380: function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      "use strict";
      __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, {
        Body: function() {
          return Body;
        }
      });
      class Body {
        loading=[];
        header=document.querySelector("header");
        async importScript(el) {
          const tagName = el.tagName.toLowerCase(), devMode = "127.0.0.1" === location.hostname || Shopify && Shopify.theme && -1 !== Shopify.theme.name.indexOf("Development") || Shopify.designMode;
          -1 === this.loading.indexOf(tagName) && (this.loading.push(tagName), customElements.get(tagName) || __webpack_require__(435)(`./${tagName}.js`).then((() => {
            devMode && console.info(`Loaded: ${tagName}`);
          })).catch((error => {
            devMode && console.warn(`Failed to load ${tagName}: ${error}`), this.loading = this.loading.splice(this.loading.indexOf(tagName));
          })));
        }
        loadScript(el) {
          if (el.hasAttribute("data-autoload")) this.importScript(el); else {
            new IntersectionObserver((async (entries, observer) => {
              entries.forEach((async entry => {
                entry.isIntersecting && (this.importScript(el), observer.disconnect());
              }));
            }), {
              rootMargin: "0px 0px 100% 0px"
            }).observe(el);
          }
        }
        bindLink(link) {
          var target = document.querySelector(link.getAttribute("href"));
          target && link.addEventListener("click", (event => {
            event.preventDefault(), window.scrollTo({
              top: target.getBoundingClientRect().top - this.header.clientHeight - 2 * parseInt(getComputedStyle(document.documentElement).getPropertyValue("--spacing-xxl")),
              left: 0,
              behavior: "smooth"
            }), window.dispatchEvent(new Event("scroll"));
          }));
        }
        constructor() {
          document.querySelectorAll("[data-async]").forEach((el => this.loadScript(el)));
          new MutationObserver(((mutationsList, observer) => {
            mutationsList.forEach((mutation => {
              mutation.target.querySelectorAll("[data-async]").forEach((el => this.loadScript(el)));
            }));
          })).observe(document.querySelector("body"), {
            childList: !0,
            subtree: !0,
            characterData: !1,
            attributes: !1
          }), document.addEventListener("keydown", (event => {
            "Escape" === event.key && document.querySelectorAll('[type="checkbox"].hidden.peer').forEach((el => el.checked = !1)), 
            document.body.classList.remove("mobile:overflow-hidden", "mobile:h-screen");
          })), document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach((el => {
            this.bindLink(el);
          }));
          new MutationObserver(((mutationsList, observer) => {
            mutationsList.forEach((mutation => {
              mutation.target.querySelectorAll('a[href^="#"]:not([href="#"])').forEach((el => this.bindLink(el)));
            }));
          })).observe(document.querySelector("body"), {
            childList: !0,
            subtree: !0,
            characterData: !1,
            attributes: !1
          });
          const sectionObserver = new IntersectionObserver(((entries, observer) => {
            entries.forEach((async entry => {
              entry.isIntersecting && entry.target.classList.remove("opacity-0", "translate-y-md");
            }));
          }), {
            rootMargin: "0px 0px 0px 0px"
          });
          document.querySelectorAll("main .shopify-section").forEach((section => {
            if (section.getBoundingClientRect().y > window.innerHeight) {
              if (section.classList.contains("block-fade")) return;
              section.classList.add("transition-all", "duration-300", "opacity-0", "translate-y-md"), 
              sectionObserver.observe(section);
            }
          }));
          setInterval((() => (() => {
            let open = !1;
            document.querySelectorAll("[data-drawer]").forEach((el => {
              el.checked && (open = !0);
            })), open ? document.body.classList.add("mobile:overflow-hidden", "mobile:h-screen") : document.body.classList.remove("mobile:overflow-hidden", "mobile:h-screen", "is-hovered");
          })()), 1e3), window.addEventListener("load", (() => document.documentElement.style.setProperty("--spacing-header-full", `${document.querySelector("header")?.clientHeight}px`))), 
          window.addEventListener("load", (() => {
            const url = window.location.href;
            if (url.includes("form_type=customer")) {
              var id = (id = url.split("#")).length > 1 ? id[id.length - 1] : "footer", form = document.querySelector(`#${id}`) || document.querySelector('footer[action^="/contact"]');
              if (form) {
                const input = form.querySelector('[type="email"]');
                if (input && input.value.length > 0) {
                  const el = document.createElement("p");
                  el.classList.add("mt-sm", "font-bold", "text-sale"), el.innerText = window.strings.existing, 
                  form.appendChild(el);
                }
              }
            }
          }));
        }
      }
    },
    435: function(module, __unused_webpack_exports, __webpack_require__) {
      var map = {
        "./announcement-bar.js": [ 911, 9, 911 ],
        "./before-after.js": [ 592, 9, 592 ],
        "./body.js": [ 380, 9 ],
        "./count-down.js": [ 956, 9, 956 ],
        "./load-more.js": [ 959, 9, 959 ],
        "./localization-form.js": [ 617, 9, 617 ],
        "./predictive-search.js": [ 116, 9, 116 ],
        "./product-form.js": [ 318, 9, 318 ],
        "./product-recommendations.js": [ 764, 9, 764 ],
        "./quick-add.js": [ 78, 9, 78 ],
        "./reviews-banner.js": [ 866, 9, 866 ],
        "./scroll-to-top.js": [ 821, 7, 821 ],
        "./shopping-cart.js": [ 445, 9, 445 ],
        "./sort-filter.js": [ 597, 9, 597 ],
        "./vanilla-slider.js": [ 758, 9, 758 ],
        "./video-player.js": [ 942, 9, 942 ]
      };
      function webpackAsyncContext(req) {
        if (!__webpack_require__.o(map, req)) return Promise.resolve().then((function() {
          var e = new Error("Cannot find module '" + req + "'");
          throw e.code = "MODULE_NOT_FOUND", e;
        }));
        var ids = map[req], id = ids[0];
        return Promise.all(ids.slice(2).map(__webpack_require__.e)).then((function() {
          return __webpack_require__.t(id, 16 | ids[1]);
        }));
      }
      webpackAsyncContext.keys = function() {
        return Object.keys(map);
      }, webpackAsyncContext.id = 435, module.exports = webpackAsyncContext;
    }
  }, __webpack_module_cache__ = {};
  function __webpack_require__(moduleId) {
    var cachedModule = __webpack_module_cache__[moduleId];
    if (void 0 !== cachedModule) return cachedModule.exports;
    var module = __webpack_module_cache__[moduleId] = {
      exports: {}
    };
    return __webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
    module.exports;
  }
  __webpack_require__.m = __webpack_modules__, __webpack_require__.n = function(module) {
    var getter = module && module.__esModule ? function() {
      return module.default;
    } : function() {
      return module;
    };
    return __webpack_require__.d(getter, {
      a: getter
    }), getter;
  }, getProto = Object.getPrototypeOf ? function(obj) {
    return Object.getPrototypeOf(obj);
  } : function(obj) {
    return obj.__proto__;
  }, __webpack_require__.t = function(value, mode) {
    if (1 & mode && (value = this(value)), 8 & mode) return value;
    if ("object" == typeof value && value) {
      if (4 & mode && value.__esModule) return value;
      if (16 & mode && "function" == typeof value.then) return value;
    }
    var ns = Object.create(null);
    __webpack_require__.r(ns);
    var def = {};
    leafPrototypes = leafPrototypes || [ null, getProto({}), getProto([]), getProto(getProto) ];
    for (var current = 2 & mode && value; "object" == typeof current && !~leafPrototypes.indexOf(current); current = getProto(current)) Object.getOwnPropertyNames(current).forEach((function(key) {
      def[key] = function() {
        return value[key];
      };
    }));
    return def.default = function() {
      return value;
    }, __webpack_require__.d(ns, def), ns;
  }, __webpack_require__.d = function(exports, definition) {
    for (var key in definition) __webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key) && Object.defineProperty(exports, key, {
      enumerable: !0,
      get: definition[key]
    });
  }, __webpack_require__.f = {}, __webpack_require__.e = function(chunkId) {
    return Promise.all(Object.keys(__webpack_require__.f).reduce((function(promises, key) {
      return __webpack_require__.f[key](chunkId, promises), promises;
    }), []));
  }, __webpack_require__.u = function(chunkId) {
    return 911 === chunkId ? "assets/app.f44c12694c2d642a31e3.js" : 592 === chunkId ? "assets/app.1d639a215490799c8609.js" : 956 === chunkId ? "assets/app.d3e7a7101c667027f065.js" : 959 === chunkId ? "assets/app.88c8ec51f4e098ce8476.js" : 617 === chunkId ? "assets/app.7bda898895067255411e.js" : 116 === chunkId ? "assets/app.6df56500e997b05cebdf.js" : 318 === chunkId ? "assets/app.9d306f20ab1bdabc1db7.js" : 764 === chunkId ? "assets/app.eae076a3f2565f2d57e3.js" : 78 === chunkId ? "assets/app.b73b037fc1ead9b4c67b.js" : 866 === chunkId ? "assets/app.37f392b4fb07b54119c4.js" : 821 === chunkId ? "assets/app.f8bf46ac7c7ab2025880.js" : 445 === chunkId ? "assets/app.06273e23d11e7a1e9014.js" : 597 === chunkId ? "assets/app.5e78ed3fdcc2f3602101.js" : 758 === chunkId ? "assets/app.839cf1c3eb92f7ea73fe.js" : 942 === chunkId ? "assets/app.d719ffbd510180543030.js" : void 0;
  }, __webpack_require__.miniCssF = function(chunkId) {}, __webpack_require__.g = function() {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || new Function("return this")();
    } catch (e) {
      if ("object" == typeof window) return window;
    }
  }(), __webpack_require__.o = function(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }, inProgress = {}, __webpack_require__.l = function(url, done, key, chunkId) {
    if (inProgress[url]) inProgress[url].push(done); else {
      var script, needAttach;
      if (void 0 !== key) for (var scripts = document.getElementsByTagName("script"), i = 0; i < scripts.length; i++) {
        var s = scripts[i];
        if (s.getAttribute("src") == url || s.getAttribute("data-webpack") == "uklash:" + key) {
          script = s;
          break;
        }
      }
      script || (needAttach = !0, (script = document.createElement("script")).charset = "utf-8", 
      script.timeout = 120, __webpack_require__.nc && script.setAttribute("nonce", __webpack_require__.nc), 
      script.setAttribute("data-webpack", "uklash:" + key), script.src = url), inProgress[url] = [ done ];
      var onScriptComplete = function(prev, event) {
        script.onerror = script.onload = null, clearTimeout(timeout);
        var doneFns = inProgress[url];
        if (delete inProgress[url], script.parentNode && script.parentNode.removeChild(script), 
        doneFns && doneFns.forEach((function(fn) {
          return fn(event);
        })), prev) return prev(event);
      }, timeout = setTimeout(onScriptComplete.bind(null, void 0, {
        type: "timeout",
        target: script
      }), 12e4);
      script.onerror = onScriptComplete.bind(null, script.onerror), script.onload = onScriptComplete.bind(null, script.onload), 
      needAttach && document.head.appendChild(script);
    }
  }, __webpack_require__.r = function(exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, function() {
    var scriptUrl;
    __webpack_require__.g.importScripts && (scriptUrl = __webpack_require__.g.location + "");
    var document = __webpack_require__.g.document;
    if (!scriptUrl && document && (document.currentScript && (scriptUrl = document.currentScript.src), 
    !scriptUrl)) {
      var scripts = document.getElementsByTagName("script");
      if (scripts.length) for (var i = scripts.length - 1; i > -1 && !scriptUrl; ) scriptUrl = scripts[i--].src;
    }
    if (!scriptUrl) throw new Error("Automatic publicPath is not supported in this browser");
    scriptUrl = scriptUrl.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/"), 
    __webpack_require__.p = scriptUrl + "../";
  }(), function() {
    var installedChunks = {
      143: 0
    };
    __webpack_require__.f.j = function(chunkId, promises) {
      var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : void 0;
      if (0 !== installedChunkData) if (installedChunkData) promises.push(installedChunkData[2]); else {
        var promise = new Promise((function(resolve, reject) {
          installedChunkData = installedChunks[chunkId] = [ resolve, reject ];
        }));
        promises.push(installedChunkData[2] = promise);
        var url = __webpack_require__.p + __webpack_require__.u(chunkId), error = new Error;
        __webpack_require__.l(url, (function(event) {
          if (__webpack_require__.o(installedChunks, chunkId) && (0 !== (installedChunkData = installedChunks[chunkId]) && (installedChunks[chunkId] = void 0), 
          installedChunkData)) {
            var errorType = event && ("load" === event.type ? "missing" : event.type), realSrc = event && event.target && event.target.src;
            error.message = "Loading chunk " + chunkId + " failed.\n(" + errorType + ": " + realSrc + ")", 
            error.name = "ChunkLoadError", error.type = errorType, error.request = realSrc, 
            installedChunkData[1](error);
          }
        }), "chunk-" + chunkId, chunkId);
      }
    };
    var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
      var moduleId, chunkId, chunkIds = data[0], moreModules = data[1], runtime = data[2], i = 0;
      if (chunkIds.some((function(id) {
        return 0 !== installedChunks[id];
      }))) {
        for (moduleId in moreModules) __webpack_require__.o(moreModules, moduleId) && (__webpack_require__.m[moduleId] = moreModules[moduleId]);
        if (runtime) runtime(__webpack_require__);
      }
      for (parentChunkLoadingFunction && parentChunkLoadingFunction(data); i < chunkIds.length; i++) chunkId = chunkIds[i], 
      __webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId] && installedChunks[chunkId][0](), 
      installedChunks[chunkId] = 0;
    }, chunkLoadingGlobal = self.webpackChunkuklash = self.webpackChunkuklash || [];
    chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0)), chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
  }(), function() {
    "use strict";
    new (__webpack_require__(380).Body);
  }();
}();